import GridComponent from "../components/GridComponent/GridComponent";
import { LeftSideComponent } from "../components/Sidebar/Sidebar";
import GridTitle from "../components/GridComponent/components/GridTitle";
import Typography from "../components/Typography/Typography";
import TimerIcon from "../assets/icons/bx-stopwatch-blue.svg";
import Rocketcon from "../assets/icons/bx-rocket-blue.svg";
import UserVoiceIcon from "../assets/icons/bx-user-voice-blue.svg";
import TrendingUpIcon from "../assets/icons/bx-trending-up-blue.svg";
import GridLGHidden from "../components/GridComponent/components/GridLGHidden";
import Header from "../components/Header/Header";
import BottomNav from "../components/BottomNav/BottomNav";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Divider from "../components/Divider/Divider";
import useSingleStudentStats from "../store/Querys/useSingleStudentStats";
import useOrganisation from "../store/Querys/useOrganisation";
import {
  LevelResponse,
  ModeUsageResponse,
  StudentStatsResponse,
} from "../store/interface";
import useStudentLevel from "../store/Querys/useStudentLevel";
import useModeUsage from "../store/Querys/useModeUsage";
import FeedbackScoreChart from "../components/FeedbackScoreChart/FeedbackScoreChart";
import DailyPracticeTimeChart from "../components/DailyPracticeTimeChart/DailyPracticeTimeChart";
import GridSMHidden from "../components/GridComponent/components/GridSMHidden";
import SessionOverviewList from "../components/SessionOverviewsList/SessionOverviewList";
import ModeUsage from "../components/ModeUsage/ModeUsage";

const IndividualStudentOverview = () => {
  const { data: adminData } = useOrganisation();
  const organizationId = adminData?.organizations?.[0]?.id;
  const { id: subUserId } = useParams<{ id: string }>();
  const { data: statsData } = useSingleStudentStats(organizationId, subUserId);
  const { data: LevelData } = useStudentLevel(organizationId, subUserId);
  const { data: modesData } = useModeUsage(organizationId, subUserId);

  return (
    <div className="flex flex-col lg:flex-row bg-[#F5F5FC]">
      <GridLGHidden>
        <Header backgroundColor="[#F5F5FC]" />
      </GridLGHidden>
      <GridComponent
        leftSideComponent={<LeftSideComponent />}
        containerClassNames={"lg:grid-cols-grid-chat-no-right-lg"}
        mainComponent={
          <MainComponent
            statsData={statsData}
            LevelData={LevelData}
            modesData={modesData}
            subUserId={subUserId || ""}
            organizationId={organizationId || ""}
          />
        }
      />
      <GridLGHidden>
        <BottomNav />
      </GridLGHidden>
    </div>
  );
};

export default IndividualStudentOverview;

const MainComponent = ({
  statsData,
  LevelData,
  modesData,
  subUserId,
  organizationId,
}: {
  statsData: StudentStatsResponse | undefined;
  LevelData: LevelResponse | undefined;
  modesData: ModeUsageResponse | undefined;
  subUserId: string;
  organizationId: string;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const getQueryParams = () => {
    const urlParams = new URLSearchParams(location.search);
    const name = urlParams.get("name");
    const lastName = urlParams.get("lastName");
    return { name, lastName };
  };

  const { name, lastName } = getQueryParams();

  return (
    <div className="flex flex-1 flex-col  bg-[#F5F5FC] lg:bg-transparent gap-24">
      <GridTitle
        title="Individual student overview"
        backBtnClick={() => navigate("/statistics")}
      />
      <div className="flex gap-24 lg:pb-[100px] max-lg:grid-cols-1  max-lg:grid">
        <div className="flex flex-col gap-24 w-[60%] max-lg:w-full max-lg:contents">
          <div className="bg-white rounded-20 border border-secondary p-24">
            <Typography type="Header3">{name + " " + lastName}</Typography>
            <Typography type="Body2" className="!text-[#868686] mt-8">
              Overview of student’s activity.
            </Typography>
            <GridSMHidden>
              <Divider className="!bg-[#EAEBF9]" />
            </GridSMHidden>
            <div className="grid grid-cols-2 gap-y-[49px] max-lg:grid-cols-1 max-lg:gap-0 max-lg:mt-16">
              <div className="flex items-center gap-12 lg:order-1">
                <div className="bg-secondary rounded-2xl p-12">
                  <img
                    src={TrendingUpIcon}
                    alt=""
                    className="w-24 h-24 lg:w-36 lg:h-36"
                  />
                </div>
                <div>
                  <Typography type="Body">
                    Level {LevelData?.currentLevel}
                  </Typography>
                  <Typography type="Body2" className="!text-[#868686] mt-[4px]">
                    Current level.
                  </Typography>
                </div>
              </div>

              <GridLGHidden>
                <Divider />
              </GridLGHidden>

              <div className="flex items-center gap-12 lg:order-3">
                <div className="bg-secondary rounded-2xl p-12">
                  <img
                    src={TimerIcon}
                    alt=""
                    className="w-24 h-24 lg:w-36 lg:h-36"
                  />
                </div>
                <div>
                  <Typography type="Body">{`${
                    statsData?.totalPracticeTime.days &&
                    statsData?.totalPracticeTime.days !== 0
                      ? `${statsData?.totalPracticeTime.days} days, `
                      : ""
                  }${
                    statsData?.totalPracticeTime.hours &&
                    statsData?.totalPracticeTime.hours !== 0
                      ? `${statsData?.totalPracticeTime.hours} hours, `
                      : ""
                  }${
                    statsData?.totalPracticeTime.minutes || "0"
                  } minutes`}</Typography>
                  <Typography type="Body2" className="!text-[#868686] mt-[4px]">
                    Total practice time.
                  </Typography>
                </div>
              </div>

              <GridLGHidden>
                <Divider />
              </GridLGHidden>

              <div className="flex items-center gap-12 lg:order-2">
                <div className="bg-secondary rounded-2xl p-12">
                  <img
                    src={UserVoiceIcon}
                    alt=""
                    className="w-24 h-24 lg:w-36 lg:h-36"
                  />
                </div>
                <div>
                  <Typography type="Body">
                    {statsData?.avgPronunciationScore === 0
                      ? "N/A"
                      : statsData?.avgPronunciationScore}
                    {statsData?.avgPronunciationScore !== 0 && "/100"}
                  </Typography>
                  <Typography type="Body2" className="!text-[#868686] mt-[4px]">
                    Average pronunciation score.
                  </Typography>
                </div>
              </div>

              <GridLGHidden>
                <Divider />
              </GridLGHidden>

              <div className="flex items-center gap-12 lg:order-4">
                <div className="bg-secondary rounded-2xl p-12">
                  <img
                    src={Rocketcon}
                    alt=""
                    className="w-24 h-24 lg:w-36 lg:h-36"
                  />
                </div>
                <div>
                  <Typography type="Body">
                    {statsData?.avgPracticeScore === 0
                      ? "N/A"
                      : statsData?.avgPracticeScore}
                  </Typography>
                  <Typography type="Body2" className="!text-[#868686] mt-[4px]">
                    Average practice score.
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <SessionOverviewList organizationId={organizationId} />
        </div>

        <div className="flex flex-col gap-24 w-[40%] max-lg:w-full max-lg:contents">
          <FeedbackScoreChart subUserId={subUserId} />
          <DailyPracticeTimeChart subUserId={subUserId} />
          <ModeUsage modesData={modesData} />
        </div>
      </div>
    </div>
  );
};
